/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSplitHeadingFragment, SplitHeadingFragment, FullSplitHeadingFragment} from '@amblique/contentful/app/contentful/fragments/split-heading';

/**
 * Get a single SplitHeading by ID (base - scalars only)
 */
export const getBaseSplitHeadingById = gql`
  ${BaseSplitHeadingFragment}

  query GetBaseSplitHeadingById($id: String!, $locale: String!, $preview: Boolean) {
    splitHeading(id: $id, locale: $locale, preview: $preview) {
      ...BaseSplitHeadingFragment
    }
  }
`;

/**
 * Get a single SplitHeading by ID (standard - 1 level deep)
 */
export const getSplitHeadingById = gql`
  ${SplitHeadingFragment}

  query GetSplitHeadingById($id: String!, $locale: String!, $preview: Boolean) {
    splitHeading(id: $id, locale: $locale, preview: $preview) {
      ...SplitHeadingFragment
    }
  }
`;

/**
 * Get a single SplitHeading by ID (full - 2 levels deep)
 */
export const getFullSplitHeadingById = gql`
  ${FullSplitHeadingFragment}

  query GetFullSplitHeadingById($id: String!, $locale: String!, $preview: Boolean) {
    splitHeading(id: $id, locale: $locale, preview: $preview) {
      ...FullSplitHeadingFragment
    }
  }
`;

/**
 * Get all SplitHeading entries with pagination (base - scalars only)
 */
export const getBaseSplitHeadings = gql`
  ${BaseSplitHeadingFragment}

  query GetBaseSplitHeadings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitHeadingOrder]
    $where: SplitHeadingFilter
    $preview: Boolean
  ) {
    splitHeadingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseSplitHeadingFragment
      }
    }
  }
`;

/**
 * Get all SplitHeading entries with pagination (standard - 1 level deep)
 */
export const getSplitHeadings = gql`
  ${SplitHeadingFragment}

  query GetSplitHeadings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitHeadingOrder]
    $where: SplitHeadingFilter
    $preview: Boolean
  ) {
    splitHeadingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...SplitHeadingFragment
      }
    }
  }
`;

/**
 * Get all SplitHeading entries with pagination (full - 2 levels deep)
 */
export const getFullSplitHeadings = gql`
  ${FullSplitHeadingFragment}

  query GetFullSplitHeadings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SplitHeadingOrder]
    $where: SplitHeadingFilter
    $preview: Boolean
  ) {
    splitHeadingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullSplitHeadingFragment
      }
    }
  }
`;
